import React, {
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react';

import { componentTypes } from '@white-nl/instantsearch-components';

import AngleDown from '../../ui/icons/sharp/regular/AngleDown';

export default function SortBy({ sortBy }: componentTypes.SortByProps) {
  const dropdownRef = useRef<HTMLDivElement>(null);

  const [isActive, setIsActive] = useState(false);

  const handleToggleClick = useCallback(() => {
    setIsActive(!isActive);
  }, [isActive, setIsActive]);

  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsActive(false);
      }
    };

    document.addEventListener('mousedown', handleOutsideClick);

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, []);

  const {
    options,
    currentRefinement,
    canRefine,
    refine,
  } = sortBy;

  if (!canRefine) {
    return null;
  }

  const selectedValue = options.find((item) => item.value === currentRefinement);

  return (
    <div
      ref={dropdownRef}
      className={`${isActive ? 'active ' : ''}group/dropdown relative z-15`}
    >
      <button
        className="btn btn-secondary w-full btn-toggle bg-light"
        type="button"
        onClick={handleToggleClick}
      >
        {selectedValue?.label}
        <AngleDown iconClass="icon" />
      </button>
      <div className="hidden text-base absolute bg-white pe-2 pb-2 top-[53px] left-0 w-full border border-dark border-t-white shadow-drop group-[.active]/dropdown:block">
        <ul className="p-0 m-0 list-none w-full max-h-117 overflow-x-hidden overflow-y-auto">
          {options.map((option) => (
            <li
              key={option.value}
              className="group/dropdown-item leading-[1.2] py-2 ps-3 pe-4.5 -me-2"
            >
              <button
                className="flex w-100 no-underline hover:decoration-accent cursor-pointer"
                type="button"
                onClick={() => {
                  refine(option.value);
                  setIsActive(false);
                }}
              >
                {option.label}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
